import React from 'react'
import { useIntl } from 'react-intl'
import LineTaxiIcon from 'LuxKit/Icons/line/LineTaxiIcon'
import OrderUpsellTileWithTracking from 'components/Common/OrderUpsellTileWithTracking'

interface Props {
  transferUpsellData: App.AirportTransferUpsell
  variant?: 'compact' | 'default'
  onDismiss?: () => void
}

function AirportTransferUpsellTile(props: Props) {
  const {
    transferUpsellData,
    variant = 'default',
    onDismiss,
  } = props
  const intl = useIntl()

  const {
    price,
    experienceSearchUrl,
  } = transferUpsellData

  return <OrderUpsellTileWithTracking
    title={intl.formatMessage({
      id: '032iKyL4PO8K97QyKSgl',
      defaultMessage: 'Airport transfers',
      description: 'Title for airport transfer upsell tile on booking confirmation',
    })}
    subTitle={intl.formatMessage({
      id: 'uKlDfbnEyDERrjkg0qeT',
      defaultMessage: 'Free cancellation available',
      description: 'Subtitle for upsell tile indicating free cancellation',
    })}
    description={intl.formatMessage({
      id: 'v2pt-LuCnYllp7MOA_Hh',
      defaultMessage: 'Reliable and private airport transfers.',
      description: 'Description for airport transfer upsell tile on booking confirmation',
    })}
    price={price}
    priceUnit="adult"
    IconComponent={LineTaxiIcon}
    to={experienceSearchUrl}
    analyticsSubject="transfer"
    variant={variant}
    onDismissClick={onDismiss}
  />
}

export default AirportTransferUpsellTile
